import { editorCardProvider } from '@atlaskit/editor-card-provider';

export const cardProvider = Promise.resolve(editorCardProvider);
